import type { Editor } from "@tiptap/react";

import type { TextEditorCommandTool } from "./TextEditor.types";

const TOOL_COMMANDS = {
  bold: "toggleBold",
  italic: "toggleItalic",
  underline: "toggleUnderline",
  strike: "toggleStrike",
  bulletList: "toggleBulletList",
  orderedList: "toggleOrderedList",
  undo: "undo",
  redo: "redo",
} as const satisfies Record<TextEditorCommandTool, string>;

export function runTool(editor: Editor, tool: TextEditorCommandTool): void {
  editor.chain().focus()[TOOL_COMMANDS[tool]]().run();
}

export function canRunTool(
  editor: Editor | null,
  tool: TextEditorCommandTool,
): boolean {
  return editor?.can().chain()[TOOL_COMMANDS[tool]]().run() ?? false;
}

export function isToolActive(
  editor: Editor | null,
  tool: TextEditorCommandTool,
): boolean {
  if (editor === null || tool === "undo" || tool === "redo") {
    return false;
  }

  return editor.isActive(tool);
}

export function readHtml(editor: Editor): string {
  return editor.isEmpty ? "" : editor.getHTML();
}
